<template>
  <modal v-if="isVisible">
    <template v-slot:header>
      <h5 class="modal-title">Изменение пароля</h5>
      <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="close">
        <span aria-hidden="true">
          <img src="@/assets/img/static/b-icon_close_x.svg">
        </span>
      </button>
    </template>

    <template v-slot:body>
      <div>
        <div class="a-container-form">
          <div class="a-label">Старый пароль:</div>
          <div class="a-form-field">
            <input type="password" class="a-input" v-model.trim="previousPassword">
            <span class="a-helper-text a-validation-error" v-if="$v.previousPassword.$dirty && !$v.previousPassword.minLength">Поле слишком короткоое</span>
          </div>
        </div>
        <div class="a-container-form">
          <div class="a-label human-data__fio-label">Новый пароль:</div>
          <div class="a-form-field">
            <input type="password" class="a-input" v-model.trim="newPassword">
            <span class="a-helper-text a-validation-error" v-if="$v.newPassword.$dirty && !$v.newPassword.required">{{$t('labels.mandatory-field')}}</span>
            <span class="a-helper-text a-validation-error" v-else-if="$v.newPassword.$dirty && !$v.newPassword.minLength">Поле слишком короткоое</span>
          </div>
        </div>
      </div>
    </template>

    <template v-slot:footer>
      <button class="gui-btn gui-btn--white-border gui-btn--ep" @click.prevent="close" v-t="'buttons.cancel'"></button>
      <button class="gui-btn gui-btn--red gui-btn--ep" @click.prevent="onSaveClick" v-t="'buttons.save'"></button>
    </template>
  </modal>
</template>

<script>
  import { required, minLength } from '@/validators'
  import Errors from '@/api/types/errors'

  export default {
    data: () => ({
      isVisible: false,
      previousPassword: undefined,
      newPassword: undefined,
    }),

    validations: {
      previousPassword: {
        required,
        minLength: minLength(8)
      },

      newPassword: {
        required,
        minLength: minLength(8)
      },
    },

    methods: {
      open() {
        this.previousPassword = undefined;
        this.newPassword = undefined;
        this.isVisible = true;
      },

      close() {
        this.isVisible = false;
        this.$emit('close');
      },

      async onSaveClick() {
        this.$v.$touch();
        if (this.$v.$invalid) {
          return;
        }

        try {
          await this.$store.dispatch('changePassword', {
            id: this.$store.getters.currentUser.id,
            previousPassword: this.previousPassword,
            newPassword: this.newPassword
          });

          this.showError({
            title: 'Смена пароля',
            error: 'Пароль успешно изменен'
          });

          this.close();
        }
        catch (e) {
          console.error('unable to change password', e);

          if (!e instanceof Errors) {
            this.showError({
              title: 'Ошибка',
              error: 'Что-то пошло не так'
            });
          }
          else if (e.BAD_PASSWORD) {
            this.showError({
              title: 'Ошибка',
              error: 'Слишком короткий пароль'
            });
          }
          else if (e.NOT_FOUND) {
            this.showError({
              title: 'Ошибка',
              error: 'Неверный старый пароль'
            });
          }
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .a-label {
    max-width: 150px;
  }
</style>
